<template>
  <div class="btn-groupz" @click="toggleMenu()" v-click-outside="onClickOutside">
    <li v-if="selectedOption.name !== undefined">
      {{ selectedOption.name }}
      <span class="caretz"></span>
    </li>

    <li class="btn-groupz"v-if="selectedOption.name === undefined">
      <span class="caretz"></span>
    </li>

    <ul class="dropdown-menuz" v-if="showMenu" >
      <li v-for="option in options">
        <a href="javascript:void(0)" @click="updateOption(option)">
          {{ option.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {

      return {

        selectedOption: {
          name: '',
        },
        showMenu: false,
      }
    },
    props: {
      options: {
        type: [Array, Object]
      },
      selected: {},
      placeholder: [String]
    },

    mounted() {
      this.ociLog("this.selected " + this.selected);
      if(!this.selected){
        this.selectedOption.name = ''
      }
      else {
        this.selectedOption = this.selected;
      }

      if (this.placeholder)
      {
        this.placeholderText = this.placeholder;
      }
    },

    methods: {
      onClickOutside (event, el) {
        this.showMenu = false;
      },

      handler (event, el) {
        this.ociLog('Clicked outside (Using config), middleware returned true :)')
      },
      // Note: The middleware will be executed if the event was fired outside the element.
      //       It should have only sync functionality and it should return a boolean to
      //       define if the handler should be fire or not
      middleware (event, el) {
        return event.target.className !== 'modal'
      },

      updateOption(option) {
        this.ociLog("Updating dropdown option");
        this.selectedOption = option;
        this.showMenu = false;
        this.$emit('updateOption', this.selectedOption);
      },

      toggleMenu() {
        this.showMenu = !this.showMenu;
      }
    }
  }
</script>

<style>

  .btn-groupz {
    min-width: 90px;
    height: 100%;
    position: relative;
    top: 0px;
    margin: 0px 1px;
    text-align: left;
    display: block;
    vertical-align: middle;

  }
  .btn-groupz a:hover {
    text-decoration: none;
  }

  .dropdown-togglez {
    color: #636b6f;
    min-width: 160px;
    padding: 10px;
    text-transform: none;
    font-weight: 300;
    margin-bottom: 7px;
    border: 0;
    background-image: linear-gradient(#009688, #009688), linear-gradient(#D2D2D2, #D2D2D2);
    background-size: 0 2px, 100% 1px;
    background-repeat: no-repeat;
    background-position: center bottom, center calc(100% - 1px);
    background-color: transparent;
    transition: background 0s ease-out;
    float: none;
    box-shadow: none;
    border-radius: 0;
  }
  .dropdown-togglez:hover {
    background: #e1e1e1;
    cursor: pointer;
  }

  .dropdown-menuz {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
    float: left;
    min-width: 100px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 0px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;
    max-height: 300px;
    overflow-y: scroll;
  }

  .dropdown-menuz > li > a {
    padding: 10px 30px;
    display: block;
    clear: both;
    font-weight: normal;
    line-height: 1.6;
    color: #333333;
    white-space: nowrap;
    text-decoration: none;
  }
  .dropdown-menuz > li > a:hover {
    background: #efefef;
    color: #007dc2;
  }

  .dropdown-menuz > li {
    overflow: hidden;
    width: 100%;
    position: relative;
    margin: 0;
  }

  .caretz {

    width:0px;

    position: relative;
    top: 10px;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-top: 4px solid \9;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    float: right;
  }

  li {
    list-style: none;
  }
</style>
